var $window = $(window);
// Sticky atc section
if($('.product-sticky-atc-grid').length > 0){
  var $container = $(".product-sticky-atc-grid"); 
  var $containerHeight = $container.innerHeight();   
  var $containerOffsetTop = $(".product-section").offset().top; 
  var $hiddencontainerheight = $(".product-section").innerHeight();
  var $containerOffset = $container.offset();
  var $finalOffsetTop = $hiddencontainerheight - $containerOffsetTop - 100;
  
  $window.scroll(function(){
      if($window.scrollTop() > $finalOffsetTop){
          $container.addClass("sticky-atc-active");   
      }else{
          $container.removeClass("sticky-atc-active");   
      }    
      if($window.scrollTop() + $containerHeight > $finalOffsetTop) {
        $container.css({"bottom": "0",});       
      } else{
        $container.css({"bottom": "0",});  
      }    
  });  
}


jQuery(document).ready(function($){
  // Product form on variation change
  $('.product-block .variant-wrapper.js .variant-input-wrap .variant-input input[type="radio"]').on('change', function(){
   if($(this).closest('.variant-wrapper').hasClass('variant-color')){
     var value = $(this).val();
     var variant_image = $('.product__main-photos .product-main-slide.is-selected image-element img').attr('src');
     if(variant_image != '' && variant_image != 'undefined' && variant_image != null){
       $('.product-sticky-atc-grid form#sticky-atc-form .sticky-atc__product img').attr('src',variant_image);
     }
   }
   
   var selected_value = ''; var selected_vprice = 0;
   var numItems = $('.product-block .variant-wrapper.js').length;

   var count = 1; 
   $('.product-block .variant-wrapper.js').each(function(){
     if(parseInt(count) < parseInt(numItems)){
       selected_value += $(this).find('.variant-input-wrap .variant-input input[type="radio"]:checked').val()+' / ';
     }else{
       selected_value += $(this).find('.variant-input-wrap .variant-input input[type="radio"]:checked').val();
     }
     count++;
   }) 

   if(selected_value != ''){
     $('.product-sticky-atc-grid #sticky-atc-form select[name="sticky-variant"] option').each(function(){ 
        if($(this).attr('data-match') == selected_value){
         $(this).attr('selected',true); 
         if($(this).attr('disabled') == 'disabled'){
           $('.product-sticky-atc-grid .atc-btn-grid button').attr('disabled',true);
           $('.product-sticky-atc-grid .atc-btn-grid button').text('Ausverkauft');
         }else{
           $('.product-sticky-atc-grid .atc-btn-grid button').removeAttr('disabled');
           $('.product-sticky-atc-grid .atc-btn-grid button').text('In den Einkaufswagen legen'); 
         } 
        }else{
          $(this).removeAttr('selected');
        }
     })


    $('#check-for-availability option').each(function(){
      if($(this).attr('data-match') == selected_value){
        if($(this).attr('disabled') == 'disabled'){
          if($(this).closest('.product-block.product-block--sales-point').hasClass('hide')){
            $(this).closest('.product-block.product-block--sales-point').removeClass('hide');
          }
          if($(this).closest('.product-block.product-block--sales-point').find('.sales-point2').hasClass('hide')){
            $(this).closest('.product-block.product-block--sales-point').find('.sales-point2').removeClass('hide');
            $(this).closest('.product-block.product-block--sales-point').find('.sales-point').addClass('hide');
          }
          var message = $(this).attr('data-message');
          console.log(message);
          $('ul.sales-points li.sales-point2 span.pre-order-text').text(message);
        }else{
         $(this).closest('.product-block.product-block--sales-point').find('.sales-point2').addClass('hide');
         $(this).closest('.product-block.product-block--sales-point').find('.sales-point').removeClass('hide');
        }
      }
    });


    var vid = $('.product-sticky-atc-grid #sticky-atc-form select[name="sticky-variant"] option:selected').val();
     
    selected_vprice = $('.product-sticky-atc-grid #sticky-atc-form select[name="sticky-variant"] option:selected').attr('data-price-nozero');
    if(typeof selected_vprice != 'undefined'){
      $(this).closest('.product-single__meta').find('.product-block--price span[data-product-price]').text(selected_vprice);
    }

    if(vid != '' && vid != 'undefined' && vid != null){
      $('form#addon-form .addon-product-grid.variation-addons .addon-row').each(function(){
        if($(this).attr('data-vid') == vid){
          $(this).show();
        }else{
          $(this).hide();
        }
      })
    }
     
   }  
    
  })


  // Sticky atc on variant change
  $('.product-sticky-atc-grid .sticky-product-variant select').on('change',function(){
    var selected_value = $(this).find('option:selected').attr('data-match');
    if($(this).find('option:selected').is(":disabled")){
      $('.product-sticky-atc-grid .atc-btn-grid button').attr('disabled',true);
      $('.product-sticky-atc-grid .atc-btn-grid button').text('Ausverkauft');
    }else{
      $('.product-sticky-atc-grid .atc-btn-grid button').removeAttr('disabled');
      $('.product-sticky-atc-grid .atc-btn-grid button').text('In den Einkaufswagen legen'); 
    }
    var selected_vid = $(this).val(); 
    var selected_value_arr = [];
    if(selected_value != '' && selected_value != 'undefined' && selected_value != null){
       selected_value_arr = selected_value.split(" / ");
    }
    if(selected_value_arr != '' && selected_value_arr != 'undefined' && selected_value_arr != null){
      $('.product-block .variant-wrapper.js .variant-input').each(function(){
        if(selected_value_arr.includes($(this).attr('data-value'))){
            $(this).find('input[type="radio"]').prop('checked',true);
            $('.product-block .variant-wrapper.js .variant-input input[type="radio"]').removeAttr('checked');
        }		
      })

      $('.product-block .variant-wrapper.js.variant-color .variant-input').each(function(){
        var selected_color = $(this).find('input[type="radio"]:checked').val();
        if(selected_color != '' && selected_color != 'undefined' && selected_color != null){
          $(this).closest('.variant-color').find('.variant__label span[data-variant-color-label]').text(selected_color);
        }
      })
    }

    if(selected_vid != '' && selected_vid != 'undefined' && selected_vid != null){
      $('.product-single__variants option').each(function(){
        if($(this).val() == selected_vid){
          $(this).attr('selected',true);
          $(this).closest('.product-single__variants').trigger('change');
        }else{
          $(this).removeAttr('selected');
        }
      })
    }
  })

  // Sticky atc on quanity increases
  $('.product-sticky-atc-grid .sticky-quantity-wrap button.btn.sticky-btn-plus').on('click',function(){
   var old_qty = $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val();
   var new_qty = 0;
   if(old_qty != '' && old_qty != 'undefined' && old_qty != null){
     new_qty = parseInt(old_qty)+parseInt(1);
   }
   if(new_qty != '' && new_qty != 'undefined' && new_qty != null){
     $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val(new_qty);
   }
  }) 

  // Sticky atc on quanity decreases
  $('.product-sticky-atc-grid .sticky-quantity-wrap button.btn.sticky-btn-minus').on('click',function(){
   var old_qty = $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val();
   var new_qty = 0;
   if(old_qty > 1){
     new_qty = parseInt(old_qty)-parseInt(1);
     if(new_qty != '' && new_qty != 'undefined' && new_qty != null){
       $(this).closest('.sticky-quantity-wrap').find('#sticky-qty').val(new_qty);
     }
   }
  })  

  // Sticky add to cart on atc button clicked
  $(document).on('click','.product-sticky-atc-grid.sticky-atc-active .atc-btn-grid button',function(e){
    e.preventDefault();
    var variant_id = $(this).closest('.product-sticky-atc-grid').find('#sticky-atc-form select[name="sticky-variant"]').val();
    var qty = $(this).closest('.product-sticky-atc-grid').find('.sticky-quantity-wrap #sticky-qty').val();
    var data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(product){ 
        var cart = new theme.CartDrawer
          cart.init()
          cart.open();
      },
      error: function(response){
        if(response.status == 400){
          alert('Error on adding product to cart. Please try again after sometime.');
        }
      }
    }); 
  })


  /************** Cart tooltip ****************/
  $('.custom-delivery-checkbox .cart-attribute__field span.cart-checkbox-tooltip').on('mouseover',function(){
    $(this).find('.tooltiptext').addClass('show');
  })  

  $('.custom-delivery-checkbox .cart-attribute__field span.cart-checkbox-tooltip').on('mouseout',function(){
    $(this).find('.tooltiptext').removeClass('show');
  })  

  /********************************************/

  // Product form button atc on clicked
  $('.product-block .product-single__form button[data-add-to-cart]').on('click',function(e){
    setTimeout(function(){
      var check_preorder = 0;
      if($('div#CartDrawer').length > 0){
        $('#CartDrawer form#CartDrawerForm .cart__items .cart__item').each(function(){
          if($(this).attr('data-item-type') == 'preorder'){
            check_preorder = 1
          }
        })

        if(check_preorder == 1){
          $('#CartDrawer').find('.custom-delivery-checkbox').addClass('show');
        }
      }
    }, 1000);
  })


  /************************ Product Addons Script ***********************/
  $('form#addon-form #addon-product-grid .addon-row .acol-6 .item-detail span.item-atc input.custom_addon_checkbox').on('click', function(){
    var variant_id = $(this).val();
    if($(this).is(':checked')){
      var qty = 1;
      var data = {
        "id": variant_id,
        "quantity": qty
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        beforeSend: function(){
          $('#addon-product-grid').addClass('fadeop');
        },
        success: function(product){ 
          $('#addon-product-grid').removeClass('fadeop');
          setTimeout(function(){
            var cart = new theme.CartDrawer
            cart.init()
            cart.open();
          }, 1000);
        },
        error: function(response){
          $('#addon-product-grid').removeClass('fadeop');
          setTimeout(function(){
            if(response.status == 400){
              alert('Error on adding product to cart. Please try again after sometime.');
            }
          }, 1000);
        }
      }); 
    }else{
      var remove_item_id = '';
      $.getJSON('/cart.js', function(cart) {
        var cart_item = cart.items;
        for(var i=0;i<cart_item.length;i++){
          if(cart_item[i].id == variant_id){
            remove_item_id = cart_item[i].id;
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              dataType: "json",
              beforeSend: function(){
                $('#addon-product-grid').addClass('fadeop');
              },
              data: {
                id: remove_item_id,
                quantity: 0,
              },
            }).then((data) => {
              $('#addon-product-grid').removeClass('fadeop');
              setTimeout(function(){
                var cart = new theme.CartDrawer
                cart.init()
                cart.open();
              }, 1000);
            });
          }
        }
      });
    }
  })

  /*********************** Product Addons Script End ********************/

  
})


/*****************Free Shipping Progress********************/ 

function updateFreeShipping(cart) {
  const threshold = 7000; // CHF 70.00 in cents
  const current = cart.total_price;
  const remaining = threshold - current;

  const msgEl = document.querySelector('.free-shipping-progress .progress-msg');
  const fillEl = document.querySelector('.free-shipping-progress .progress-fill');
    const shippingStatus = document.getElementById('shipping-status');


  if (!msgEl || !fillEl) return;

  if (current >= threshold) {
    msgEl.innerHTML = '🎉 Glückwunsch! Du hast <strong>KOSTENLOSEN Versand!</strong>';
    if (shippingStatus) {
      shippingStatus.textContent = 'Kostenlos';
      shippingStatus.style = 'color:green;';
    }
  } else {
    msgEl.innerHTML = `🚚 Du brauchst noch <strong>${(remaining / 100).toFixed(
      2
    )} CHF</strong> um kostenlosen Versand zu erhalten!`;
    if (shippingStatus) {
      shippingStatus.textContent = 'Im Checkout berechnet'; 
      shippingStatus.style = 'color:black;';
    }
  }

  let percent = Math.min(100, (current / threshold) * 100);
  fillEl.style.width = percent + '%';

  console.log(percent+' ppppppppppppppppppppppppp');
}

function refreshFreeShipping() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateFreeShipping(cart));
}


document.addEventListener('ajaxProduct:added', function(event) {
    refreshFreeShipping();
});


// Always run on cart updates too
document.addEventListener('cart:updated', refreshFreeShipping);

document.addEventListener('cart:drawer:open', refreshFreeShipping);



// product page tooltip 24/06/25
$(document).ready(function(){
$('.mor-info-badge').click(function(){
 $(this).parent().find('.productimg-tooltipdesc').fadeToggle(500); 
}); 
});

  

